var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg018RemoveUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.672,280.596c-21.691-15.587-45.306-27.584-70.182-35.778C370.565,219.986,392,180.449,392,136 C392,61.01,330.991,0,256,0S120,61.01,120,136c0,44.504,21.488,84.084,54.633,108.911c-30.368,9.998-58.863,25.555-83.803,46.069 c-45.732,37.617-77.529,90.086-89.532,147.743c-3.762,18.066,0.745,36.622,12.363,50.908C25.222,503.847,42.365,512,60.693,512 H267c11.046,0,20-8.954,20-20c0-11.046-8.954-20-20-20H60.693c-8.538,0-13.689-4.766-15.999-7.606 c-3.989-4.905-5.533-11.29-4.236-17.519c20.756-99.695,108.691-172.521,210.24-174.977c1.759,0.068,3.526,0.102,5.302,0.102 c1.788,0,3.569-0.035,5.341-0.104c44.466,1.052,86.883,15.236,122.988,41.182c8.969,6.446,21.467,4.399,27.913-4.569 C418.688,299.539,416.642,287.042,407.672,280.596z M260.869,231.878c-1.621-0.03-3.244-0.045-4.869-0.045 c-1.614,0-3.228,0.016-4.84,0.046C200.465,229.35,160,187.312,160,136c0-52.935,43.065-96,96-96s96,43.065,96,96 C352,187.302,311.55,229.334,260.869,231.878z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.285,427l50.857-50.857c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.811-20.474-7.811-28.284,0L427,398.715 l-50.858-50.858c-7.811-7.811-20.474-7.811-28.284,0c-7.81,7.811-7.811,20.475,0,28.285L398.715,427l-50.857,50.857 c-7.811,7.811-7.811,20.475,0,28.285C351.763,510.048,356.881,512,362,512c5.119,0,10.237-1.952,14.142-5.857L427,455.285 l50.858,50.858C481.763,510.048,486.881,512,492,512c5.119,0,10.237-1.952,14.142-5.857c7.811-7.811,7.811-20.475,0-28.285 L455.285,427z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg018RemoveUser);
export default __webpack_public_path__ + "static/media/018-remove-user.ab18b3ca603ffab9e5070fc49ac2c1be.svg";
export { ForwardRef as ReactComponent };